// lietas, kuras saistītas ar quicksearchu
// biome-ignore lint/complexity/useArrowFunction: This is Angular
angular.module("myApp").factory("quickSearch", function () {
  const unaccent = (s) => {
    return (s || "")
      .toLowerCase()
      .replaceAll("ā", "a")
      .replaceAll("č", "c")
      .replaceAll("ē", "e")
      .replaceAll("ģ", "g")
      .replaceAll("ī", "i")
      .replaceAll("ķ", "k")
      .replaceAll("ļ", "l")
      .replaceAll("ņ", "n")
      .replaceAll("š", "s")
      .replaceAll("ū", "u")
      .replaceAll("ž", "z")
      .replace(/[^a-z\d]/g, " ")
      .replace(/[ ][ ]+/g, " ")
      .trim()
  }

  const make_index = (obj) => {
    return unaccent(JSON.stringify(Object.values(obj).filter((c) => !!c)))
  }

  const prepare_terms = (s) => {
    return unaccent(s).trim().split(/\s+/)
  }

  const matches_filter = (obj, search_text) => {
    if (!search_text || search_text.length === 0) {
      return true
    }

    // assume prepared terms
    let search_terms = search_text
    if (typeof search_text === "string") {
      search_terms = prepare_terms(search_text)
    }
    if (!obj.index) {
      // no index? create one from the whole obj.
      // mutably store the index. not clean, but comfy
      obj.index = make_index(obj)
    }

    return search_terms.every((term) => obj.index.includes(term))
  }

  return { unaccent, make_index, matches_filter }
})
